import callCmAPI from 'services/helpers/callCmAPI'

export const updateUser = ({ userId, data }) =>
  callCmAPI(`/user/${userId}`, {
    method: 'put',
    data,
  })
    .then((res) => res.data)
    .catch((err) => err)
